module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        Card ใช้สำหรับแสดงผลกลุ่มของ Content ในลักษณะ Card รูปแบบต่างๆ\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentButton'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Button\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentForm'
      }
    }
  }, [_vm._v("\n            Form   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-card"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Card\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio-message -warning _fs-6 _mgbt-64px"
  }, [_c('p', [_c('strong', [_vm._v("ข้อควรระวัง")]), _vm._v(" – Card สร้างโดยใช้ CSS Grid จึง Support เฉพาะ "), _c('a', {
    staticClass: "bio-link -fancy",
    attrs: {
      "href": "https://caniuse.com/#feat=css-grid",
      "target": "_blank"
    }
  }, [_vm._v("Modern Browser")]), _vm._v(" เท่านั้น 😖\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card")]), _vm._v(" "), _c('small', {
    staticClass: "_opct-60"
  }, [_vm._v("(Container)")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-cover")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-title")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-subtitle")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-content")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Style: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-horizontal")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-cover")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-title")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-subtitle")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-content")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-card-actions")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Style: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-attached")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-push-left")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Basic Card -->\n<div class=\"bio-card\">\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n</div>\n\n<!-- Basic Card with Title / Subtitle -->\n<div class=\"bio-card\">\n  <div class=\"bio-card-title\"><strong>Hello World</strong></div>\n  <div class=\"bio-card-subtitle\">@BioMaRu</div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n</div>\n\n<!-- Basic Card with Cover -->\n<div class=\"bio-card\">\n  <img class=\"bio-card-cover\" src=\"https://placeimg.com/640/480/animals\" alt=\"image\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-subtitle\">@BioMaRu</div>\n</div>\n\n<div class=\"bio-card\">\n  <img class=\"bio-card-cover\" src=\"https://placeimg.com/640/480/animals\" alt=\"image\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-subtitle\">@BioMaRu</div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-card _mgbt-16px"
  }, [_c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n            Aenean efficitur sit amet massa fringilla egestas.\n            Nullam condimentum luctus turpis.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card _mgbt-16px"
  }, [_c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello World")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-subtitle"
  }, [_vm._v("@BioMaRu")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n            Aenean efficitur sit amet massa fringilla egestas.\n            Nullam condimentum luctus turpis.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 lo-6-sm -gap-16px"
  }, [_c('div', {
    staticClass: "bio-card _ovf-hd _als-st _mgbt-16px"
  }, [_c('img', {
    staticClass: "bio-card-cover",
    attrs: {
      "src": "https://placeimg.com/360/128/animals",
      "alt": "image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-subtitle"
  }, [_vm._v("@BioMaRu")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card _ovf-hd  _mgbt-16px"
  }, [_c('img', {
    staticClass: "bio-card-cover",
    attrs: {
      "src": "https://placeimg.com/360/128/animals",
      "alt": "image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-subtitle"
  }, [_vm._v("@BioMaRu")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n              Aenean efficitur sit amet massa fringilla egestas.\n              Nullam condimentum luctus turpis.\n            ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Card แบบ ")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("-horizontal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"bio-card -horizontal\">\n  <img class=\"bio-card-cover\" src=\"https://placeimg.com/360/360/animals\" alt=\"image\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-subtitle\">@BioMaRu</div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "bio-card -horizontal"
  }, [_c('img', {
    staticClass: "bio-card-cover",
    attrs: {
      "src": "https://placeimg.com/360/360/animals",
      "alt": "image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-subtitle"
  }, [_vm._v("@BioMaRu")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n            Aenean efficitur sit amet massa fringilla egestas.\n            Nullam condimentum luctus turpis.\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Card ที่มี Actions รูบแบบต่างๆ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Basic Actions -->\n<div class=\"bio-card\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n  <div class=\"bio-card-actions\">\n    <a class=\"bio-link _pdh-8px\" href=\"#\">Cancel</a>\n    <a class=\"bio-link _pdh-8px\" href=\"#\">OK</a>\n  </div>\n</div>\n\n<!-- Actions with with -push-left -->\n</div>\n  <div class=\"bio-card\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n  <div class=\"bio-card-actions -push-left\">\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-facebook _fs-5\"></i></a>\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-google _fs-5\"></i></a>\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-twitter _fs-5\"></i></a>\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-instagram _fs-5\"></i></a>\n  </div>\n</div>\n\n<!-- Actions with with -attached -->\n<div class=\"bio-card\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n  <div class=\"bio-card-actions -attached\">\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-facebook _fs-5\"></i></a>\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-google _fs-5\"></i></a>\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-twitter _fs-5\"></i></a>\n    <a class=\"bio-link\" href=\"#\"><i class=\"fa fa-instagram _fs-5\"></i></a>\n  </div>\n</div>\n\n<!-- Actions with with -attached -->\n<div class=\"bio-card\">\n  <div class=\"bio-card-title\"><strong>Hello Kitty</strong></div>\n  <div class=\"bio-card-content\">\n    ...\n  </div>\n  <div class=\"bio-card-actions -attached\">\n    <a class=\"bio-link _pdh-8px\" href=\"#\">Cancel</a>\n    <a class=\"bio-link _pdh-8px\" href=\"#\">OK</a>\n  </div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "lo-12 lo-6-sm -gap-16px"
  }, [_c('div', {
    staticClass: "bio-card"
  }, [_c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n              Aenean efficitur sit amet massa fringilla egestas.\n              Nullam condimentum luctus turpis.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-actions"
  }, [_c('a', {
    staticClass: "bio-link _pdh-8px",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "bio-link _pdh-8px",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("OK")])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card _als-st"
  }, [_c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n              Aenean efficitur sit amet massa fringilla egestas.\n              Nullam condimentum luctus turpis.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-actions -push-left"
  }, [_c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook _fs-5"
  })]), _vm._v(" "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-google _fs-5"
  })]), _vm._v(" "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter _fs-5"
  })]), _vm._v(" "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram _fs-5"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card _als-st"
  }, [_c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n              Aenean efficitur sit amet massa fringilla egestas.\n              Nullam condimentum luctus turpis.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-actions -attached"
  }, [_c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook _fs-5"
  })]), _vm._v(" "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-google _fs-5"
  })]), _vm._v(" "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter _fs-5"
  })]), _vm._v(" "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram _fs-5"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card _als-st"
  }, [_c('div', {
    staticClass: "bio-card-title"
  }, [_c('strong', [_vm._v("Hello Kitty")])]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-content"
  }, [_vm._v("\n              Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n              Aenean efficitur sit amet massa fringilla egestas.\n              Nullam condimentum luctus turpis.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "bio-card-actions -attached"
  }, [_c('a', {
    staticClass: "bio-link _pdh-8px",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "bio-link _pdh-8px",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("OK")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-497a81ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/ComponentCard.vue
// module id = 127
// module chunks = 0